module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassic-Bold-16f4c0059126a171912c3d24f61a79fa.otf";